import { Link } from 'react-router-dom';
import type { ShowItem } from '@/mocks/shows';
import ShowCard from './ShowCard';

interface Props {
  title: string;
  description: string;
  icon: string;
  items: ShowItem[];
  moreTo: string;
  tone?: 'primary' | 'accent';
}

export default function TopicSection({ title, description, icon, items, moreTo, tone = 'primary' }: Props) {
  const toneClass = tone === 'accent' ? 'bg-accent-500' : 'bg-primary-500';
  return (
    <section className="mx-auto max-w-[1440px] px-4 md:px-8 py-10">
      <div className="bg-background-100 rounded-xl p-5 md:p-8">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <span className={`flex h-10 w-10 items-center justify-center rounded-lg ${toneClass} text-background-50`}>
              <i className={`${icon} text-lg`}></i>
            </span>
            <div>
              <h2 className="font-heading text-lg md:text-xl font-black text-foreground-950">{title}</h2>
              <p className="text-xs md:text-sm text-foreground-500 font-body">{description}</p>
            </div>
          </div>
          <Link to={moreTo} className="hidden sm:flex items-center gap-1 text-sm text-primary-600 font-label font-medium cursor-pointer whitespace-nowrap">
            专题合集
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6">
          {items.map((item) => (
            <ShowCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}